<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="24">
                <el-descriptions title="商品信息">
                    <el-descriptions-item label="商品名称">{{productItem.itemName}}</el-descriptions-item>
                    <el-descriptions-item label="商品类型">{{productItem.itemTypeName}}</el-descriptions-item>
                </el-descriptions>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="12">
                <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                         :size="GCONFIG.styleElFormSize">
                    <el-form-item label="批次名称">
                        <el-input v-model="formInline.ticketBatchName" placeholder="批次名称"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-tooltip class="item" effect="dark" content="输入券名查询可选优惠券" placement="top">
                            <el-button type="primary" @click="getList">查询</el-button>
                        </el-tooltip>
                    </el-form-item>
                </el-form>
                <el-table :data="getCashticketBatchList" stripe border center :size="GCONFIG.styleTableSize"
                          v-loading="loading">
                    <el-table-column prop="ticketBatchId" label="批次ID"></el-table-column>
                    <el-table-column prop="ticketBatchName" label="批次名称"></el-table-column>
                    <el-table-column prop="createTime" label="创建时间" sortable></el-table-column>
                    <el-table-column prop="discountModeName" label="折扣"></el-table-column>
                    <el-table-column prop="discountOrAmount" label="金额/比例" sortable></el-table-column>
                    <el-table-column prop="userName" label="创建人"></el-table-column>
                    <el-table-column label="操作" fixed="right" width="200">
                        <template slot-scope="scope">
                            <el-button-group>
                                <el-button type="warning" size="mini" @click="save(scope.row)">选择</el-button>
                            </el-button-group>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination-wrap">
                    <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="formInline.currentPage"
                            :page-sizes="GCONFIG.pageSizes"
                            :page-size="formInline.pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="formInline.recordsTotal">
                    </el-pagination>
                </div>
            </el-col>
            <el-col :span="12">
                <el-descriptions title="可用优惠券列表">
                    <el-descriptions-item label="可用优惠券列表">可用优惠券列表</el-descriptions-item>
                </el-descriptions>
                <el-table :data="checkedCashRuleItemList" stripe border center v-loading="loading" label="已选优惠券">
                    <template slot="header" slot-scope="scope">
                        <span>已选列表</span>
                    </template>
                    <el-table-column prop="ticketBatchId" label="批次ID"></el-table-column>
                    <el-table-column prop="ticketBatchName" label="批次名称"></el-table-column>
                    <el-table-column prop="createTime" label="创建时间" sortable></el-table-column>
                    <el-table-column prop="discountModeName" label="折扣"></el-table-column>
                    <el-table-column prop="discountOrAmount" label="金额/比例" sortable></el-table-column>
                    <el-table-column prop="userName" label="创建人"></el-table-column>
                    <el-table-column label="操作" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="danger" size="mini" @click="deleteRule(scope.row)">删除

                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        getCashticketBatchList,
        getQueryList,
        deleteCashticketBatch,
        setCashCache,
        saveCashRuleNew,
        deleteProductCashRule,
        getProductCashList,
        getProductItem
    } from '../../api/api'

    //定义组件
    export default {
        data() {
            return {
                getCashticketBatchList: [],
                cashCreateTypeEnum: [],
                cashDiscountModeEnum: [],
                checkedCashRuleItemList: [],
                loading: true,
                itemId: '',
                itemType: '',
                productItem: {
                    itemName: '',
                    itemTypeName: '',
                    itemType: 0
                },
                form: {
                    ticketBatchId: '',
                    ticketBatchName: '',
                    ticketType: 0,
                    createType: 3,
                    ticketPosition: 7,
                    minUseamount: 0,
                    quantity: 100,
                    discountMode: 0,
                    discountAmount: 100,
                    amount: 0,
                    periodType: 2,
                    days: 7,
                    userTackCount: 1,
                    remark: '',
                    status: 1,
                    ticetClass: '',
                    ticketNoNum: 1,
                    userVisible: 1,
                    digital: 1,
                    cashUseUrl: '',
                    beginTime: '',
                    endTime: '',
                    composeUse: 0
                },
                formInline: {
                    ticketBatchId: "",
                    ticketBatchName: "",
                    createType: "",
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0,
                },
            }
        },
        props: ['itemId', 'itemType'],
        //挂载时候执行
        mounted() {
            //获取查询条件下拉列表
            this.getProductItemInfo()
            this.getSelectCash()
            getQueryList({}).then((res) => {
                this.cashCreateTypeEnum = res.data.value.cashCreateTypeEnum;
                this.cashCreateTypeEnum.pop();
                this.cashDiscountModeEnum = res.data.value.cashDiscountModeEnum;
                this.getList();
            });
        },
        methods: {
            getProductItemInfo(){
                this.loading = true;
                getProductItem({
                    itemId: this.itemId,
                    itemType: this.itemType
                }).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.productItem = res.data.value;
                    }
                })
            },
            //定义查询方法
            getList() {
                this.loading = true;
                getCashticketBatchList(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '查询成功',
                            type: 'success'
                        });
                        this.formInline.recordsTotal = res.data.value.total;
                        this.getCashticketBatchList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            getSelectCash(){
                getProductCashList({
                    itemId: this.itemId,
                    itemType: this.itemType,
                    currentPage: 1,
                    pageSize: 100
                }).then(res => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.checkedCashRuleItemList = res.data.value
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            save(row, itemType){
                for (var i = 0; i < this.checkedCashRuleItemList.length; i++) {
                    if (this.checkedCashRuleItemList[i].ticketBatchId === row.ticketBatchId) {
                        this.$message({
                            showClose: true,
                            message: row.ticketBatchName + '已存在',
                            type: 'error'
                        });
                        return;
                    }
                }
                this.loading = true;
                saveCashRuleNew({
                    ruleDetailId: row.ticketBatchId,
                    ruleTypeId: 9,
                    itemType: this.itemType,
                    ticketBatchId: this.itemId
                }).then(res => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        this.getSelectCash();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            deleteRule(row){
                this.$confirm('是否删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const loading = this.$loading(this.GCONFIG.loadingParam);
                    deleteProductCashRule({ticketBatchId: row.ticketBatchId,itemId:this.itemId, itemType: this.itemType,ruleType:9}).then((res) => {
                        loading.close();
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {
                });
            },
            handledDelete(row) {
                this.$confirm('禁用优惠劵批次, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const loading = this.$loading(this.GCONFIG.loadingParam);
                    deleteCashticketBatch({ticketBatchId: row.ticketBatchId}).then((res) => {
                        loading.close();
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {
                });
            },
            convertStatus(row, column, cellValue) {
                if (row.status == 1) {
                    return "启用";
                } else {
                    return "禁用";
                }
            },
            convertVisible(row, column, cellValue) {
                if (row.userVisible == 1) {
                    return "可见";
                } else {
                    return "不可见";
                }
            },
            convertCashType(row, column, cellValue) {
                if (row.digital == 1) {
                    return "数字";
                } else {
                    return "字母混合";
                }
            },
            setCashCache4Old(){
                setCashCache().then((res) => {
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/coupon/productCash.vue